/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/organisation-role.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import {
    getFieldChangeItems,
    getPermissionsData,
    getProcessedFieldChangeItems,
    removePropertiesFromObject,
} from 'views/pages/admin/audit-log/service';

const propArray = ['Modules'];

const OrganisationRoleRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const refactoredOldRecord = {
        ...oldRecord,
        ...removePropertiesFromObject(oldRecord, propArray),
        Role: oldRecord.Name,
        Name: null,
    };
    const refactoredNewRecord = {
        ...newRecord,
        ...removePropertiesFromObject(newRecord, propArray),
        Role: newRecord.Name,
        Name: null,
    };

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) => {
        if (field === 'Rights')
            return getPermissionsData(
                refactoredOldRecord,
                refactoredNewRecord,
                Object.keys(refactoredNewRecord).find((key) => key === 'Rights'),
            );
        return getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
        });
    });

    return <FieldChangeGrid items={items} />;
};

export { OrganisationRoleRecordChangeGrid };
